import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { tokenStore } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError("No session_id in URL.");
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Persist token for cookie-blocked browsers (Safari ITP / strict mode).
        if (data?.token) tokenStore.set(data.token);
        // Clear URL fragment
        window.history.replaceState(null, "", "/admin/dashboard");
        await checkAuth();
        navigate("/admin/dashboard", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || e?.message || "Auth failed";
        setError(msg);
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center font-body">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-rose-400 text-sm mb-3">{error}</div>
            <a href="/admin/login" className="text-zinc-400 hover:text-white text-sm">
              Back to login
            </a>
          </>
        ) : (
          <div className="text-zinc-500 text-sm tracking-[0.18em] uppercase">
            Authenticating…
          </div>
        )}
      </div>
    </div>
  );
}
